import Styles from "./Dashboard.module.scss";
import clsx from "clsx";
import React, { useState, useEffect, useCallback } from "react";
import { LineChart } from "../../../Share/Component/Chart/lineChart";
import { CallApiGetDashboard } from "../../../Api/Enforcement";
import { handleGetToken } from "../../../Share/Func/Storage";
import TableUserEmtyComponent from "../../../Share/Component/Empty";
import { DatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

function AdminDashboard() {
  const [date, setDate] = useState({
    month: dayjs().month() + 1,
    year: dayjs().year(),
  });
  const [data, setData] = useState();
  const current = dayjs()
    .year(date.year)
    .month(date.month - 1);

  const handleCallApi = useCallback(() => {
    CallApiGetDashboard(date, handleGetToken(), (res) => {
      if (res.Status === "success") {
        setData(res.Response.data);
      } else {
        setData(null);
      }
    });
  }, [date]);

  useEffect(() => {
    handleCallApi();
  }, [handleCallApi]);

  const handleDateChange = (value) => {
    if (value && !isNaN(value.year()) && !isNaN(value.month())) {
      setDate({ month: value.month() + 1, year: value.year() });
    }
  };

  return (
    <div className={clsx(Styles.main)}>
      <div className={clsx(Styles.bodyMain)}>
        <div className={clsx(Styles.datePicker)}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              variant="inline"
              openTo="month"
              views={["year", "month"]}
              label="Year and Month"
              helperText="Start from year selection"
              value={current}
              onChange={handleDateChange}
            />
          </LocalizationProvider>
        </div>
        {data ? (
          <LineChart dataChart={data} date={date} />
        ) : (
          <TableUserEmtyComponent />
        )}
      </div>
      {data ? <DataReport data={data} /> : <></>}
    </div>
  );
}

export default AdminDashboard;

export function DataReport({ data }) {
  const notes = [
    "[Type]: Biểu diễn cho Knb có [Type]",
    "K-[Type]: Biểu diễn cho KnbKhoa có [Type]",
  ];

  return (
    <div className={clsx(Styles.wrap)}>
      <div className={clsx(Styles.note)}>
        <h5>Ghi chú :</h5>
        <ul>
          {notes.map((note, index) => (
            <li key={index}>{note}</li>
          ))}
        </ul>
      </div>
      <div className={clsx(Styles.bodyDetail)}>
        <h5>Thống kê:</h5>

        <div className={Styles.group}>
          <div className={clsx(Styles.groupDetail)}>
            <div className={clsx(Styles.detail)}>
              <div
                className={clsx(Styles.type)}
                style={{ borderColor: "#78d6d5" }}
              >
                {" "}
              </div>
              <h6>Pay:</h6>
              <div className={clsx(Styles.value)}>
                <h6>
                  {data.reduce(
                    (acc, current) => acc + (current.pay || current.Pay || 0),
                    0
                  )}
                </h6>
              </div>
            </div>
            <div className={clsx(Styles.detail)}>
              <div
                className={clsx(Styles.type)}
                style={{ borderColor: "#9ca116" }}
              >
                {" "}
              </div>
              <h6>Distribution:</h6>
              <div className={clsx(Styles.value)}>
                <h6>
                  {data.reduce(
                    (acc, current) =>
                      acc + (current.distribution || current.Distribution || 0),
                    0
                  )}
                </h6>
              </div>
            </div>
          </div>

          <div className={clsx(Styles.groupDetail)}>
            <div className={clsx(Styles.detail)}>
              <div
                className={clsx(Styles.type)}
                style={{ borderColor: "#ae54cc" }}
              >
                {" "}
              </div>
              <h6>NoCount:</h6>
              <div className={clsx(Styles.value)}>
                <h6>
                  {data.reduce(
                    (acc, current) =>
                      acc + (current.no_count || current.NoCount || 0),
                    0
                  )}
                </h6>
              </div>
            </div>
            <div className={clsx(Styles.detail)}>
              <div
                className={clsx(Styles.type)}
                style={{ borderColor: "#e6b55c" }}
              >
                {" "}
              </div>
              <h6>BuyBack:</h6>
              <div className={clsx(Styles.value)}>
                <h6>
                  {data.reduce(
                    (acc, current) =>
                      acc + (current.buy_back || current.BuyBack || 0),
                    0
                  )}
                </h6>
              </div>
            </div>
          </div>

          <div className={clsx(Styles.groupDetail)}>
            <div className={clsx(Styles.detail)}>
              <div
                className={clsx(Styles.type)}
                style={{ borderColor: "#3fc736" }}
              >
                {" "}
              </div>
              <h6>K-Pay:</h6>
              <div className={clsx(Styles.value)}>
                <h6>
                  {data.reduce(
                    (acc, current) =>
                      acc + (current.k_pay || current.KPay || 0),
                    0
                  )}
                </h6>
              </div>
            </div>
            <div className={clsx(Styles.detail)}>
              <div
                className={clsx(Styles.type)}
                style={{ borderColor: "#3235db" }}
              >
                {" "}
              </div>
              <h6>K-Distribution:</h6>
              <div className={clsx(Styles.value)}>
                <h6>
                  {data.reduce(
                    (acc, current) =>
                      acc +
                      (current.k_distribution || current.KDistribution || 0),
                    0
                  )}
                </h6>
              </div>
            </div>
          </div>

          <div className={clsx(Styles.groupDetail)}>
            <div className={clsx(Styles.detail)}>
              <div
                className={clsx(Styles.type)}
                style={{ borderColor: "#d14532" }}
              >
                {" "}
              </div>
              <h6>K-NoCount:</h6>
              <div className={clsx(Styles.value)}>
                <h6>
                  {data.reduce(
                    (acc, current) =>
                      acc + (current.k_no_count || current.KNoCount || 0),
                    0
                  )}
                </h6>
              </div>
            </div>
            <div className={clsx(Styles.detail)}>
              <div
                className={clsx(Styles.type)}
                style={{ borderColor: "#003300" }}
              >
                {" "}
              </div>
              <h6>K-BuyBack:</h6>
              <div className={clsx(Styles.value)}>
                <h6>
                  {data.reduce(
                    (acc, current) =>
                      acc + (current.k_buy_back || current.KBuyBack || 0),
                    0
                  )}
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
